var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealerLandingSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.997 3a7.997 7.997 0 0 1 7.998 7.997l-.007.333a7.918 7.918 0 0 1-1.683 4.566l3.4 3.389c.394.398.391 1.03 0 1.42a1.001 1.001 0 0 1-1.42 0l-3.39-3.4a7.917 7.917 0 0 1-4.898 1.69l-.249-.004A7.998 7.998 0 0 1 10.998 3zm0 2a5.998 5.998 0 1 0 0 11.996l.225-.005A5.998 5.998 0 0 0 10.998 5z",
    fill: "#4C4C4E",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerLandingSearch);
export default __webpack_public_path__ + "static/media/dealer-landing-search.96af9b91db9460c5712baa390be9f98e.svg";
export { ForwardRef as ReactComponent };